import { getPendingExternalRedirectApp } from "./external-redirect";

export interface AuthBackground {
  /** Full-resolution background image. */
  imageUrl?: string;
  /** Tiny LQIP for progressive blur-up while `imageUrl` loads. */
  placeholderImageUrl?: string;
  /** Rendered as a full-bleed CSS gradient when set and imageUrl isn't. */
  gradient?: string;
}

export interface AuthPresentation {
  background: AuthBackground;
  titleKey: string;
  subtitleKey: string;
}

const DEFAULT_PRESENTATION: AuthPresentation = {
  background: {
    imageUrl: "/images/pro-auth-bg.webp",
    placeholderImageUrl: "/images/pro-auth-bg-thumb.webp",
    // Falls back to this gradient if the image above hasn't been added yet
    // (AuthPageLayout swaps to it automatically on image load failure).
    gradient: "linear-gradient(135deg, #111928 0%, #1f2937 45%, #4b3a12 100%)",
  },
  titleKey: "account.login.title",
  subtitleKey: "account.login.subtitle",
};

const CERTIFICATION_PRESENTATION: AuthPresentation = {
  background: {
    imageUrl: "/images/certification/hero.png",
    placeholderImageUrl: "/images/certification/hero-thumb.webp",
  },
  titleKey: "account.login.certTitle",
  subtitleKey: "account.login.certSubtitle",
};

/** Picks login/register copy + background based on which app (if any) sent the visitor here. */
export function getAuthPresentation(): AuthPresentation {
  const app = getPendingExternalRedirectApp();
  if (app === "certification") return CERTIFICATION_PRESENTATION;
  return DEFAULT_PRESENTATION;
}
